"use client";

import { c as _c } from "react/compiler-runtime";
import { RelatedMatches as PostRelatedMatches } from "@/views/post/partials/RelatedMatches/RelatedMatches";
import { useLabels } from "@/lib/labels/LabelsProvider";
export interface RelatedMatchesProps {
  /** Maximum number of matches to display */
  maxItems?: number;
  /** Custom container className */
  className?: string;
  /** Whether to show the section header */
  showHeader?: boolean;
  /** Custom title override */
  title?: string;
}

/**
 * RelatedMatches - Displays related matches from the article context.
 * Thin wrapper over post RelatedMatches that provides article-specific labels.
 */
export function RelatedMatches(props) {
  const $ = _c(3);
  const labels = useLabels();
  let t0;
  if ($[0] !== labels.articlePage.relatedMatches || $[1] !== props) {
    t0 = <PostRelatedMatches {...props} matchesLabel={labels.articlePage.relatedMatches} />;
    $[0] = labels.articlePage.relatedMatches;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}